export class WorkflowTemplate {
  WorkflowID: number = -1;
  Name: string = '';
  Description: string = '';
  ActionCount: number = 0;
  MandatoryActionCount: number = 0;
  LastUpdated: Date | null = null;
  CreatedBy?: string;

  constructor(values: Partial<WorkflowTemplate> = {}) {
    Object.assign(this, values);
    if (values && (values as any).LastUpdated) {
      this.LastUpdated = values.LastUpdated ? new Date(values.LastUpdated as any) : null;
    }
  }
}
